import { render, staticRenderFns } from "./MessageAvatar.vue?vue&type=template&id=8d0eae64"
import script from "./MessageAvatar.vue?vue&type=script&lang=js"
export * from "./MessageAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports